import Vue from 'vue';
import _ from 'lodash'
Vue.prototype._ = _